import script from "./DashBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./DashBoard.vue?vue&type=script&setup=true&lang=js"

import "./DashBoard.vue?vue&type=style&index=0&id=710dd493&lang=css"

const __exports__ = script;

export default __exports__